import clsx from "clsx";
import React from "react";
import { TextInput } from "../criteria/TextInput";

interface FavoriteListNameInputProps {
	autoFocus?: boolean;
	error?: string;
	onChange: React.ReactEventHandler<HTMLInputElement>;
	onFocus?: React.ReactEventHandler<HTMLInputElement>;
}

export function FavoriteListNameInput({
	autoFocus,
	error,
	onChange,
	onFocus,
}: FavoriteListNameInputProps) {
	return (
		<div className={clsx("form-group", { error })}>
			<TextInput
				id="favorite-list-name"
				name="favorite"
				placeholder="List name"
				label="Create new list"
				error={error}
				autoFocus={autoFocus}
				onChange={onChange}
				onFocus={onFocus}
			/>
		</div>
	);
}
